import "../css/Popups.css";

function Inventory({onClose}){
    return(
        <div className="shade">
            <section id="popup">
                <div className="top">
                    <h1>Inventory</h1>
                    <button onClick={onClose} className="closeBtn">X</button>
                </div>

                <div className="mid">
                    
                    <div>
                        <h2>My Inventory</h2>
                        <ul>
                            <li>Vs Code</li>
                            <li>Bootstrap</li>
                            <li>Xampp</li>
                            <li>Git</li>
                            <li>Chai</li>
                        </ul>
                    </div>
                </div>

                <div className="bottom">
                    <img src={require("../images/about-bottom.png")} alt="" width="100%" height="50px" />
                </div>
            </section>
        </div>

    )
}
 export default Inventory;